module.exports = __webpack_public_path__ + "static/img/logo-hdtransys.372eca8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/logo-hdtransys.png
// module id = Xwy6
// module chunks = 0